export default __webpack_public_path__ + "static/element_solutions_mob-684ae67a6e636d1b88d026e0cf9cc79e.png";